function toggleIcon(e) {
    $(e.target)
        .prev('.content-question')
        .find(".more-less")
        .toggleClass('glyphicon-plus glyphicon-minus');
}

$('#accordion').on('hidden.bs.collapse', toggleIcon);
$('#accordion').on('shown.bs.collapse', toggleIcon);


function toggleIconArrow(e) {
    $(e.target)
        .next('.panel-heading')
        .find(".glyphicon")
        .toggleClass('glyphicon-chevron-up glyphicon-chevron-down');
}

$('.panel-content-curso').on('hidden.bs.collapse', toggleIconArrow);
$('.panel-content-curso').on('shown.bs.collapse', toggleIconArrow);

$("#menu-curso a[href^='#']").on("click", function(e) {
	e.preventDefault();
	$("html, body").animate({
		scrollTop: $($(this).attr("href")).offset().top - 50
	}, 1000);
});

$(".btn-programacao").on("click", function(e) {
    e.preventDefault();
    var text = $('.btn-programacao span').text();
    if(text == 'Ver programação completa'){
        $('.btn-programacao span').text('Ver menos');
        $('.btn-programacao .fa').removeClass('fa-chevron-down').addClass('fa-chevron-up');
    } else {
        $('.btn-programacao span').text('Ver programação completa');
        $('.btn-programacao .fa').removeClass('fa-chevron-up').addClass('fa-chevron-down');
    }
    $("html, body").animate({
        scrollTop: $('#programacao').offset().top
    }, 0);
});

$(".btn-como-funciona").on("click", function(e) {
    e.preventDefault();

    $('.btn-como-funciona .fa').toggleClass('fa-chevron-down fa-chevron-up');

    $("html, body").animate({
        scrollTop: $('.btn-programacao').offset().top - 50
    }, 0);
});


$(".btn-scroll").on("click", function(e) {
    e.preventDefault();

    var cta = $(this).attr('cta');
    $('#cta_conversao').val(cta);

    $("html, body").animate({
        scrollTop: $('#mais-info').offset().top - 150
    }, 1000);
});